import { Platform, StatusBar } from 'react-native';

import { isEqual as _isEqual } from 'lodash';

class PositionsProvider {
  positions = {};
  subscribers = [];
  subscribe = subscriber => {
    this.subscribers.push(subscriber);
  };

  pushPosition = pos => {
    if (!this.positions[pos.id]) {
      this.positions[pos.id] = { ...pos.value, isLoading: true };
      this.notifySubscribers();
    } else {
      const newPosition = { ...this.positions[pos.id], ...pos.value };
      if (!_isEqual(this.positions[pos.id], newPosition)) {
        this.positions[pos.id] = newPosition;
        this.notifySubscribers();
      }
    }
  };
  setLoading = (id, status) => {
    this.pushPosition({ id, value: { isLoading: status } });
  };

  notifySubscribers = () => {
    this.subscribers.forEach(subscriber => {
      subscriber(this.positions);
    });
  };

  getStatusBarHeight = isAbsolute => {
    if (Platform.OS === 'ios' || isAbsolute) {
      return 0;
    }
    return StatusBar.currentHeight;
  };

  measure({ id, ref, isAbsolute }) {
    setTimeout(() => {
      ref?.measure((_, __, width, height, x, y) =>
        this.pushPosition({
          id,
          value: {
            x,
            y: y - this.getStatusBarHeight(isAbsolute),
            width,
            height,
          },
        }),
      );
    });
  }
}
export default new PositionsProvider();
